import PieChart from "@arelia-components/ui-atoms/PieChart";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Card, CardContent, CardHeader } from "@mui/material";

type Props = {
  data: { label: string; value: number, total: number }[];
  loading: boolean;
};

export function LikesPiechart({ data, loading }: Props) {
  return <Card sx={styles.card}>
    <CardHeader
      title="Likes"
    />
    <CardContent>
      <SpinnerWrapper loading={loading}>
        <PieChart
          data={data}
          title="Likes"
        />
      </SpinnerWrapper>
    </CardContent>
  </Card>;
}

const styles = {
  card: {
    gridColumn: "span 6",
    gridRow: "span 6",
  }
};